//百度统计
document.write(unescape("%3Cscript src='https://hm.baidu.com/hm.js%3F5fe61289b7abcfc464f0bf31593ca6f8' type='text/javascript'%3E%3C/script%3E"))
